// extracted by mini-css-extract-plugin
export var adjacentSlide = "_ni-9";
export var arrowButtonContainer = "_ni-5";
export var arrowButtonIcon = "_ni-6";
export var carouselArrowButton = "_ni-2";
export var carouselElementContainer = "_ni-1";
export var currentSlide = "_ni-8";
export var left = "_ni-3";
export var otherSlide = "_ni-a";
export var productCarouselContainer = "_ni-0";
export var right = "_ni-4";
export var sliderOverflow = "_ni-7";